import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ui-sidebar-brand',
  templateUrl: './ui-sidebar-brand.component.html',
  styleUrls: ['./ui-sidebar-brand.component.scss']
})
export class UiSidebarBrandComponent {
  @Input() logoText = 'PA';
  @Input() companyName = 'Pradhan Associates';
  @Input() appName = 'SupplySync ERP';
  @Input() collapsed = false;
}
